const landingKey = 'lanla.campaign.landing';
export const CAMPAIGN_PROOF_TTL_MS = 10 * 60 * 1000;
export interface CampaignProof {
  state: string;
  verifier: string;
  expires: number;
}
export function createCampaignProof(state: string, verifier: string, now = Date.now()): CampaignProof {
  return {
    state,
    verifier,
    expires: now + CAMPAIGN_PROOF_TTL_MS
  };
}
export function readCampaignProof(serialized: string | null, state: string | null, now = Date.now()): CampaignProof | undefined {
  if (!serialized || serialized.length > 4096 || !state) {
    return undefined;
  }
  try {
    const proof = JSON.parse(serialized);
    return proof && typeof proof === 'object' && !Array.isArray(proof) && typeof proof.state === 'string' && proof.state.length >= 43 && proof.state.length <= 128 && !/[^A-Za-z0-9._~-]/.test(proof.state) && typeof proof.verifier === 'string' && proof.verifier.length >= 43 && proof.verifier.length <= 128 && !/[^A-Za-z0-9._~-]/.test(proof.verifier) && typeof proof.expires === 'number' && Number.isFinite(proof.expires) && proof.expires > now && proof.expires <= now + CAMPAIGN_PROOF_TTL_MS && proof.state === state ? proof : undefined;
  } catch {
    return undefined;
  }
}
export interface CampaignLanding {
  uid?: string;
  expires: number;
  lat?: number;
  lng?: number;
}
export function hasFamilyCampaignContext(routeCampaign: unknown, search: string) {
  return routeCampaign === 'family' || new URLSearchParams(search).get('campaign') === 'family';
}
export function readCampaignLanding(): CampaignLanding | undefined {
  if (typeof sessionStorage === 'undefined') {
    return undefined;
  }
  try {
    const value = JSON.parse(sessionStorage.getItem(landingKey) || 'null');
    return value && value.expires > Date.now() ? value : undefined;
  } catch {
    return undefined;
  }
}
export function saveCampaignLanding(value: Omit<CampaignLanding, 'expires'>) {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  sessionStorage.setItem(landingKey, JSON.stringify({
    ...value,
    expires: Date.now() + 24 * 60 * 60 * 1000
  }));
}
export function clearCampaignLanding() {
  if (typeof sessionStorage !== 'undefined') {
    sessionStorage.removeItem(landingKey);
  }
}
export function campaignSecret() {
  const bytes = crypto.getRandomValues(new Uint8Array(32));
  return btoa(String.fromCharCode(...bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
export async function campaignChallenge(verifier: string) {
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier));
  return btoa(String.fromCharCode(...new Uint8Array(digest))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}
